
export default {

    userInfo:  {
        cards: [
            {
                pan: '9900063003045143',
                comment: '',
                main: true,
                secureAllowed: true
            },
            {
                pan: '9900063003045142',
                comment: 'Ленина, 54',
                main: false,
                secureAllowed: false
            },
            {
                pan: '9900063003045144',
                comment: 'Титова, 15',
                main: false,
                secureAllowed: true
            },
            {
                pan: '9900063003045145',
                comment: 'Комсомольская, 86',
                main: false,
                secureAllowed: false
            }/* ,
            {
                pan: '9900063003045146',
                comment: 'Пионеров, 1',
                main: false,
                secureAllowed: true
            } */
        ],
        
        contacts: {
            phone: '',//'8005553535',
            email: '',// 'geralt@plotva.riv',
        },

        settings: {
      
            counterRemind: ['phone', 'email'], // or [], or ['phone'],
            
            receiptEmail: ['9900063003045143', '9900063003045142'], 
            
            contactForProvider: 'phone',
            
            secureAccounts: ['9900063003045143']
        },
    },

    getUserInfo() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve(this.userInfo);
            }, 1000);
        });
    },

   

    setSettings(partialSettings) {
        return new Promise((resolve, reject) => {
 
            setTimeout(() => {
              resolve();
            }, 100);
        });
    },


}